import { CommonPageWrapper, HeadingWrapper } from 'admin/components/wrappers';
import { PageMainLabel } from 'app/components/SHLabel';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import RiderInformationFirstBlock from './RiderInformationFirstBlock';
import AdminTab from 'app/components/AdminTab';
import RiderInformationFrom from './RiderInformationFrom';
import ParentDetails from './ParentDetails';
import styled from 'styled-components';
import BackButton from 'app/components/BackButton';
import AdminCustomButton from 'app/components/AdminCustomButton';
import CustomBreadCrumb from 'app/components/CustomBreadCrumb';
import { useParams } from 'react-router-dom';
import { AdminRiderRegistration, GeneralLookup } from 'services/openapi';
import SchoolDetails from './SchoolDetails';
import {
  defaultRiderValue,
  parentDetailsTabValidation,
  riderInfoTabValidation,
  schoolTabValidation,
  tabRiderNamesArray,
} from './staticDatas';
import useCommonLookUpDatas from 'hooks/useCommonLookupData';
import useRiderApi from 'admin/hooks/useRiderApi';
import {
  findMatchingDivisionClassAndRemoveSelected,
  findObjectById,
  getLookupArray,
} from 'utils/common';
import SimpleReactValidator from 'simple-react-validator';
import { CommonLoader } from 'app/components/CommonLoader';
import Cookies from 'js-cookie';
import { useRiderRegistrationApi } from 'hooks/useRiderRegistrationApi';

export type heightWeightModel = {
  feet: number | undefined;
  inches: number | undefined;
  weight: number | undefined;
};

const PAGE_SIZE = 20;

const RiderCreateViewPage = () => {
  let { action, id: riderId } = useParams();
  const {
    fetchRiderInfo,
    updateOrCreateRiders,
    riderInfo,
    loading,
    riderDataLoading,
    checkBacknumberTaken,
    isBacknumberTaken,
    setIsBacknumberTaken,
  } = useRiderApi();

  const {
    getAllLookupData,
    lookUps,
    loading: lookUpLoading,
  } = useCommonLookUpDatas();

  const [heightWeight, setHeightWeight] = useState<heightWeightModel>();
  const [tabSelected, setTabSelected] = useState<number>(0);
  const [riderData, setRiderdata] =
    React.useState<AdminRiderRegistration>(defaultRiderValue);
  const [defaultRiderData, setDefaultRiderdata] =
    React.useState<AdminRiderRegistration>(defaultRiderValue);
  const simpleValidator = useRef(new SimpleReactValidator());
  const [categoryListFromTeam, setCategoryListFromTeam] = React.useState<Array<GeneralLookup>>([]);
  const [divisionOneList, setDivisionOnelist] = React.useState<Array<GeneralLookup>>([]);
  const [divisionTwoList, setDivisionTwoList] = React.useState<Array<GeneralLookup>>([]);
  const [triggor, setTriggor] = React.useState(false);
  const [triggorTwo, setTriggorTwo] = React.useState(false);
  const [isCategoryNotInTeam, setIsCategoryNotInTeam] = useState(false);
  const [valid, setValid] = useState<boolean>(false);
  const [imgSrc, setImgSrc] = React.useState<string | null>('');
  const [imageFile, setImageFile] = React.useState<Blob>();
  const userType = Cookies.get('userType') ?? '';
  const [isReturningRider, setIsReturningRider] = useState<boolean>(false);

  const {
    getRidersList,
    riderSearchList,
    loading: riderSearchLoading,
    getRiderInfo,
    riderInfo: riderDetails,
  } = useRiderRegistrationApi();

  const [seasonValue, setSeasonValue] = useState<GeneralLookup>();
  const [returningRiderData, setReturningRiderData] = useState<Array<GeneralLookup>>();
  const [selectedReturningRider, setSelectedReturningRider] = useState<GeneralLookup>();

  const debounceTimerRef = useRef<NodeJS.Timeout | null>(null);
  const isInitializedRef = useRef(false);
  const previousSearchValueRef = useRef<string | undefined>('');
  const initialSeasonRef = useRef<GeneralLookup | undefined>(undefined);

  //pagination refs for infinite scroll
  const currentPageRef = useRef<number>(1);
  const hasMoreRef = useRef<boolean>(true);
  const riderSearchLoadingRef = useRef(false);
  const seasonValueRef = useRef<GeneralLookup | undefined>(undefined);

  const breadCrumpitems = [
    {
      id: '',
      text: userType === 'COACH' ? 'Showyeda coach' : 'Showyeda admin',
      disabled: true,
    },
    {
      id: userType === 'COACH' ? '/coach/riders' : '/admin/riders',
      text: 'Riders',
    },
    { id: '', text: 'Rider Info', disabled: true },
  ];

  const handleChange = event => {
    const { name, value } = event.target;
    const nameArray = name.split('.');
    const updateNestedState = (prevState, keys, newValue) => {
      const [firstKey, ...remainingKeys] = keys;
      if (remainingKeys.length === 0) {
        return { ...prevState, [firstKey]: newValue };
      }
      return {
        ...prevState,
        [firstKey]: updateNestedState(prevState[firstKey], remainingKeys, newValue),
      };
    };
    setRiderdata(prevData => updateNestedState(prevData, nameArray, value));
  };

  const onSaveClick = () => {
    let fieldsData = simpleValidator.current.fields;
    if (isReturningRider && action === 'create') {
      delete fieldsData['Rider First Name'];
      delete fieldsData['Rider Last Name'];
    } else {
      delete fieldsData['Rider Name'];
    }
    let isFormValid = simpleValidator.current.allValid();
    let emailValid = fieldsData['Rider Email'];
    let isriderInfoTabValid = riderInfoTabValidation(riderData);
    let isSchoolTabValid = schoolTabValidation(riderData);
    let isParentDetailsTabValid = parentDetailsTabValidation(riderData);

    if (!emailValid) setTabSelected(0);

    if (isReturningRider) {
      delete fieldsData['Rider First Name'];
      delete fieldsData['Rider Last Name'];
    } else {
      delete fieldsData['Rider Name'];
    }

    if (valid || isFormValid) {
      if (isriderInfoTabValid || !emailValid) {
        setTabSelected(0);
      } else if (isSchoolTabValid) {
        setTabSelected(1);
      } else if (isParentDetailsTabValid) {
        setTabSelected(2);
      } else {
        const riderDataPayload = { ...riderData, isReturningRider };
        updateOrCreateRiders(riderDataPayload, imageFile);
      }
      if (isriderInfoTabValid || isSchoolTabValid || isParentDetailsTabValid) {
        simpleValidator.current.showMessages();
        setTriggor(!triggor);
      }
    } else {
      if (isriderInfoTabValid) setTabSelected(0);
      else if (isSchoolTabValid) setTabSelected(1);
      else if (isParentDetailsTabValid) setTabSelected(2);
      simpleValidator.current.showMessages();
      setTriggor(!triggor);
    }
  };

  const onCancelClick = () => {
    setTriggorTwo(!triggorTwo);
    setIsCategoryNotInTeam(false);
    simpleValidator.current.hideMessages();
    simpleValidator.current.visibleFields = [];
    setImgSrc(riderInfo?.imageUrl!);
    setRiderdata(defaultRiderData);
    setImageFile(undefined);
    setSelectedReturningRider(undefined);
    setHeightWeight({ feet: undefined, inches: undefined, weight: undefined });
  };

  const handleBackClick = () => {
    window.history.back();
  };

  const handleSameAddressCheckbox = e => {
    if (e.value) {
      setRiderdata?.({
        ...riderData,
        parent: {
          ...riderData.parent,
          sameAsRiderAddress: true,
          state: riderData.state,
          street: riderData.street,
          city: riderData.city,
          zip: riderData.zip,
        },
      });
    } else {
      setRiderdata?.({
        ...riderData,
        parent: {
          ...riderData.parent,
          sameAsRiderAddress: false,
          state: { id: '', name: '', children: null },
          street: '',
          city: '',
          zip: '',
        },
      });
    }
  };

  const convertInputValue = (value: string): number | string => {
    const trimmedValue = value.trim();
    const num = Number(trimmedValue);
    if (!isNaN(num) && trimmedValue !== '') return num;
    return value;
  };
  useEffect(() => {
    riderSearchLoadingRef.current = riderSearchLoading;
  }, [riderSearchLoading]);

  useEffect(() => {
    seasonValueRef.current = seasonValue;
  }, [seasonValue]);

  // ADD: stable callback, reads everything from refs
  const handleRiderDropdownScrollBottom = useCallback(() => {
    if (!hasMoreRef.current || riderSearchLoadingRef.current) return;

    const nextPage = currentPageRef.current + 1;
    currentPageRef.current = nextPage;
    riderSearchLoadingRef.current = true;

    const currentSeason = seasonValueRef.current || initialSeasonRef.current;
    if (currentSeason?.id) {
      getRidersList(
        currentSeason.id,
        undefined,
        previousSearchValueRef.current || undefined,
        undefined,
        undefined,
        undefined,
        false,
        nextPage,
        PAGE_SIZE,
        true,
      );
    }
  }, [getRidersList]);
  const handleSearchInputChange = useCallback(
    e => {
      const value = e?.filter?.value ?? '';
      if (previousSearchValueRef.current === value) return;
      previousSearchValueRef.current = value;
      // reset page on every new search
      currentPageRef.current = 1;
      hasMoreRef.current = true;

      if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
      debounceTimerRef.current = setTimeout(() => {
        const currentSeason = seasonValue || initialSeasonRef.current;
        if (isReturningRider && currentSeason?.id) {
          const searchValue = value ? convertInputValue(value) : undefined;
          if (typeof searchValue === 'number') {
            getRidersList(
              currentSeason.id, searchValue.toString(), undefined,
              undefined, undefined, undefined,
              false, 1, PAGE_SIZE, false,
            );
          } else if (searchValue) {
            getRidersList(
              currentSeason.id, undefined, searchValue as string,
              undefined, undefined, undefined,
              false, 1, PAGE_SIZE, false,
            );
          } else {
            getRidersList(
              currentSeason.id, undefined, undefined,
              undefined, undefined, undefined,
              false, 1, PAGE_SIZE, false,
            );
          }
        }
      }, 500);
    },
    [isReturningRider, seasonValue?.id, getRidersList],
  );

  // Update returningRiderData from API response + track hasMore
  useEffect(() => {
    const list = riderSearchList?.riders ?? [];
    const { count = 0, currentPage = 1 } = riderSearchList?.pageDetails ?? {};

    hasMoreRef.current = count > currentPage * PAGE_SIZE;

    // Reset loading ref now that response is back
    riderSearchLoadingRef.current = false;

    if (list.length) {
      setReturningRiderData(
        list
          .filter(item => item.id != null)
          .map(item => ({
            id: item.id,
            name: `${item.firstName || ''} ${item.lastName || ''}`.trim(),
          })) as GeneralLookup[],
      );
    } else {
      setReturningRiderData([]);
    }
  }, [riderSearchList]);

  // Initialize season and fetch initial rider data ONCE
  useEffect(() => {
    if (lookUps && !isInitializedRef.current && isReturningRider) {
      const season =
        lookUps
          .find(obj => obj.type === 'SEASON')
          ?.values?.find(item => item.isAdminLive === true) ?? undefined;

      initialSeasonRef.current = season;
      setSeasonValue(season);
      isInitializedRef.current = true;

      if (season?.id) {
        getRidersList(
          season.id, undefined, undefined,
          undefined, undefined, undefined,
          false, 1, PAGE_SIZE, false,
        );
      }
    }
  }, [lookUps, isReturningRider]);

  // Cleanup debounce timer on unmount
  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
    };
  }, []);

  useEffect(() => {
    if (selectedReturningRider) {
      getRiderInfo(selectedReturningRider?.id, seasonValue?.id);
    }
  }, [selectedReturningRider, seasonValue]);

  useEffect(() => {
    if (riderDetails && isReturningRider) {
      const populated: AdminRiderRegistration = {
        riderStatus: riderData.riderStatus,
        adminCreatedDate: riderData.adminCreatedDate,
        isTransferredTeam: riderData.isTransferredTeam,
        isAvailableBackNumber: riderData.isAvailableBackNumber,
        riderId: riderDetails.id,
        firstName: riderDetails.firstName ?? '',
        lastName: riderDetails.lastName ?? '',
        backNumber: riderDetails.backNumber,
        team: riderDetails.team,
        category: riderDetails.category ?? { id: '', name: '', children: null },
        divisionClassOne: riderDetails.divisionClassOne,
        divisionClassTwo: riderDetails.divisionClassTwo,
        height: riderDetails.height,
        weight: riderDetails.weight,
        street: riderDetails.street ?? '',
        city: riderDetails.city ?? '',
        state: riderDetails.state,
        zip: riderDetails.zip ?? '',
        primaryPhone: riderDetails.primaryPhone ?? '',
        email: riderDetails.email ?? '',
        school: riderDetails.school,
        grade: riderDetails.currentGrade,
        expectedGraduationYear: riderDetails.expectedGraduationYear,
        parent: riderDetails.parent,
        isTrial: riderDetails.isTrial ?? false,
        isSif: false,
        isReturningRider: riderDetails.isReturningRider ?? true,
        sifJoinedDate: null,
        sifAmountPaid: null,
        sifPoint: null,
      };
      setRiderdata(populated);

      const heightInCm = riderDetails.height || 0;
      const totalInches = heightInCm / 2.54;
      const feet = Math.floor(totalInches / 12);
      const inches = Math.round(totalInches % 12);
      setHeightWeight({
        feet: feet || undefined,
        inches: inches || undefined,
        weight: riderDetails.weight ? riderDetails.weight : undefined,
      });

      if (riderDetails.team?.id) {
        const teamLookUpList = getLookupArray('ACTIVETEAM', lookUps);
        const matchingTeam = findObjectById(teamLookUpList, riderDetails.team.id);
        if (matchingTeam?.children) setCategoryListFromTeam(matchingTeam.children);
      }

      if (riderDetails.category?.id) {
        const categoryLookUpList = getLookupArray('CATEGORY', lookUps);
        const matchingCategory = findObjectById(categoryLookUpList, riderDetails.category.id);
        if (matchingCategory?.children) setDivisionOnelist(matchingCategory.children);
      }
    }
  }, [riderDetails]);

  useEffect(() => {
    if (riderDetails?.divisionClassOne && divisionOneList.length > 0 && isReturningRider) {
      const division = getLookupArray('DIVISION', lookUps);
      const filteredDivisionTwoList = findMatchingDivisionClassAndRemoveSelected(
        riderDetails.divisionClassOne,
        division,
        divisionOneList,
      );
      setDivisionTwoList(filteredDivisionTwoList);
    }
  }, [divisionOneList]);

  React.useEffect(() => {
    if (riderInfo) {
      const updatedObject = {
        ...riderInfo,
        sifAmountPaid: riderInfo.sifAmountPaidPerYear,
        sifAmountPaidPerYear: undefined,
        sifJoinedDate: riderInfo.sifJoinDate,
        sifJoinDate: undefined,
        sifPoint: riderInfo.sifPoint,
      };
      setImgSrc(riderInfo?.imageUrl!);
      setRiderdata(updatedObject as AdminRiderRegistration);
      const heightInCm = riderInfo?.height || 0;
      const totalInches = heightInCm / 2.54;
      const feet = Math.floor(totalInches / 12);
      const inches = Math.round(totalInches % 12);
      setIsReturningRider(riderInfo.isReturningRider || false);
      setHeightWeight({
        feet: feet || undefined,
        inches: inches || undefined,
        weight: riderInfo.weight ? riderInfo.weight : undefined,
      });
      setDefaultRiderdata(updatedObject as AdminRiderRegistration);
    }
  }, [riderInfo]);

  React.useEffect(() => {
    let teamLookUpList = getLookupArray('ACTIVETEAM', lookUps);
    const matchingObject = findObjectById(teamLookUpList, riderInfo?.team?.id!);
    if (matchingObject) {
      const { children } = matchingObject;
      setCategoryListFromTeam(children!);
    }
    let categoryLookUpList = getLookupArray('CATEGORY', lookUps);
    const matchingCategoryObject = findObjectById(
      categoryLookUpList,
      riderInfo?.category?.id!,
    );
    if (matchingCategoryObject) {
      const { children } = matchingCategoryObject;
      setDivisionOnelist(children!);
    }
    let division = getLookupArray('DIVISION', lookUps);
    let filteredDivisionTwoList = findMatchingDivisionClassAndRemoveSelected(
      riderInfo?.divisionClassOne!,
      division,
      divisionOneList,
    );
    setDivisionTwoList(filteredDivisionTwoList);
  }, [lookUps]);

  React.useEffect(() => {
    getAllLookupData('CATEGORY,DIVISION,ACTIVESTATUS,STATE,GRADE,ACTIVETEAM,SEASON');
    if (riderId) fetchRiderInfo(riderId);
  }, [riderId]);

  React.useEffect(() => {
    const formValid = simpleValidator.current.allValid();
    setValid(formValid);
  }, [riderData, imageFile, riderInfo]);

  return (
    <>
      <CommonPageWrapper>
        {loading && <CommonLoader loaderType="main" />}
        <HeadingWrapper>
          <PageMainLabel>Rider Information</PageMainLabel>
          <CustomBreadCrumb preData={breadCrumpitems} />
        </HeadingWrapper>
        <BtnWrapper>
          <div>
            <BackButton onClick={handleBackClick} className="back-button-style" />
          </div>
          <div className="btn-action">
            <AdminCustomButton buttonType="cancel" onClick={onCancelClick}>
              Clear
            </AdminCustomButton>
            <AdminCustomButton buttonType="save" onClick={onSaveClick}>
              Save
            </AdminCustomButton>
          </div>
        </BtnWrapper>
        <RiderInformationFirstBlock
          riderData={riderData}
          handleChange={handleChange}
          setRiderdata={setRiderdata}
          action={action}
          lookUps={lookUps}
          categoryListFromTeam={categoryListFromTeam}
          setCategoryListFromTeam={setCategoryListFromTeam}
          divisionOneList={divisionOneList}
          setDivisionOnelist={setDivisionOnelist}
          divisionTwoList={divisionTwoList}
          setDivisionTwoList={setDivisionTwoList}
          simpleValidator={simpleValidator}
          setImgSrc={setImgSrc}
          imgSrc={imgSrc}
          setImageFile={setImageFile}
          riderDataLoading={riderDataLoading || lookUpLoading}
          isCategoryNotInTeam={isCategoryNotInTeam}
          setIsCategoryNotInTeam={setIsCategoryNotInTeam}
          checkBacknumberTaken={checkBacknumberTaken}
          isBacknumberTaken={isBacknumberTaken}
          setIsBacknumberTaken={setIsBacknumberTaken}
          heightWeight={heightWeight}
          setHeightWeight={setHeightWeight}
          isReturningRider={isReturningRider}
          setIsReturningRider={setIsReturningRider}
          setSelectedReturningRider={setSelectedReturningRider}
          handleSearchInputChange={handleSearchInputChange}
          selectedReturningRider={selectedReturningRider}
          returningRiderData={returningRiderData}
          setSeasonValue={setSeasonValue}
          setReturningRiderData={setReturningRiderData}
          previousSearchValueRef={previousSearchValueRef}
          seasonValue={seasonValue}
          onCancelClick={onCancelClick}
          getRidersList={getRidersList}
          onRiderDropdownScrollBottom={handleRiderDropdownScrollBottom}
        />
        {!(riderDataLoading || lookUpLoading) && (
          <TabWrapper>
            <AdminTab
              data={tabRiderNamesArray}
              tabSelected={tabSelected}
              setTabSelected={setTabSelected}
            />
          </TabWrapper>
        )}
        <div className="sub-wrapper">
          {tabSelected === 0 ? (
            <RiderInformationFrom
              riderData={riderData}
              handleChange={handleChange}
              setRiderdata={setRiderdata}
              lookUps={lookUps}
              simpleValidator={simpleValidator}
              action={action}
              riderDataLoading={riderDataLoading || lookUpLoading}
            />
          ) : tabSelected === 1 ? (
            <SchoolDetails
              riderData={riderData}
              handleChange={handleChange}
              setRiderdata={setRiderdata}
              lookUps={lookUps}
              simpleValidator={simpleValidator}
              riderDataLoading={riderDataLoading || lookUpLoading}
            />
          ) : tabSelected === 2 ? (
            <ParentDetails
              riderData={riderData}
              handleChange={handleChange}
              setRiderdata={setRiderdata}
              lookUps={lookUps}
              simpleValidator={simpleValidator}
              riderDataLoading={riderDataLoading || lookUpLoading}
              handleSameAddressCheckbox={handleSameAddressCheckbox}
            />
          ) : (
            ''
          )}
        </div>
      </CommonPageWrapper>
    </>
  );
};

export default RiderCreateViewPage;

const TabWrapper = styled.div`
  margin-top: 20px;
`;
const BtnWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  padding: 15px 0;
  .back-button-style{
    button{
      padding: 0px !important;
    }
  }
  @media (min-width: 1480px) and (max-width: 1899px) {
    padding: 15px 20px 15px 0;
  }
  @media (min-width: 1899px) and (max-width: 4000px) {
    padding: 15px 35px 15px 0;
  }
  .btn-action {
    display: flex;
    align-items: center;
    gap: 15px;
  }
`;
